import(/* webpackMode: "eager" */ "/private/tmp/statura-proddeploy-Z0WbEy/apps/web/src/app/(auth)/error.tsx");
